import {LeaderboardHorizontalTabData} from '../../../../../../../shared/leaderboard_data/LeaderboardInterfaces'
import {UILeaderboardUtils} from '../../../../../../shared/scripts/ui_leaderboard/UILeaderboardUtils'

export class UIMLeaderboardHorizontalTabsController {
    private readonly tabElementsContainer: HTMLDivElement

    private readonly onHorizontalTabChange: (leaderboardUrl: string) => void

    constructor(onHorizontalTabChange: (leaderboardUrl: string) => void) {
        this.tabElementsContainer = document.querySelector('.leaderboard_tabs_item_list') as HTMLDivElement
        this.onHorizontalTabChange = onHorizontalTabChange
    }

    highlightTab(leaderboardUrl: string) {
        for(const tab of this.tabElementsContainer.children) {
            const tabElement = tab as HTMLElement
            if(tabElement.dataset.leaderboardUrl == leaderboardUrl) {
                tab.classList.add('m-tab-active')
            } else {
                tab.classList.remove('m-tab-active')
            }
        }
    }

    updateLeaderboardRegionTabs(availableHorizontalTabs: LeaderboardHorizontalTabData[], leaderboardUrl: string) {
        if(this.tabElementsContainer.children.length > 0) return
        for(const tab of availableHorizontalTabs) {
            const div = document.createElement('div')
            div.classList.add('leaderboard_tabs_item')
            div.classList.add('m-no-drag')
            div.innerText = UILeaderboardUtils.tLeaderboardTabName(tab.label)
            if(leaderboardUrl == tab.leaderboardUrl) div.classList.add('m-tab-active')

            div.addEventListener('click', () => {
                this.onHorizontalTabChange(tab.leaderboardUrl)
            })
            div.dataset.leaderboardUrl = tab.leaderboardUrl

            this.tabElementsContainer.appendChild(div)
        }
    }
}
